import { z } from 'zod';
export const ExperienceLevel = z.nativeEnum({
  New: 'new',
  Medium: 'medium',
  Experienced: 'experienced'
});
export const UserFormSchema = z.object({
  pfp: z.string().min(1, 'Select an avatar'),
  username: z.string().min(4, 'Username must contain at least 4 characters').max(20, 'Username can not have more than 20 characters').transform(value => !value.startsWith('@') ? `@${value}` : value),
  first_name: z.string().min(1, 'First name cannot be empty'),
  // last_name: z.string().min(1, 'Last name cannot be empty'),
  experience: ExperienceLevel,
  referral_code: z.string().optional()
});
export const _checkUsernameAvailability = async username => {
  const _url = `/api/db/checkUsername?username=${username}`;
  try {
    const _res = await fetch(_url);
    // Username has not been taken
    if (_res.status === 404) return true;
    // Username has been taken
    if (_res.status === 200) return false;
  } catch (error) {
    console.error('[_checkUsernameAvailability]', {
      error
    });
    throw new Error('error _checkUsernameAvailability');
  }
};
export const _updateDbCloudInfo = async _data => {
  const _resp = await fetch('/api/db/setProfile', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(_data)
  });
  const _result = await _resp.json();
  return {
    status: _resp.status,
    data: _result
  };
};
export const _updateDbProfile = async _data => {
  const _resp = await fetch('/api/db/updateProfile', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(_data)
  });
  const _result = await _resp.json();
  return {
    status: _resp.status,
    data: _result
  };
};
export var StagesProfileForm;
(function (StagesProfileForm) {
  StagesProfileForm["default"] = "default";
  StagesProfileForm["isCheckingUsername"] = "is checking username";
  StagesProfileForm["isUpdatingAccount"] = "is creating account";
})(StagesProfileForm || (StagesProfileForm = {}));